import { FC } from 'react';

import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '@savgroup-front-common/primitive/ui/drawer';

import { CreateActionMenuItem } from '../CreateActionMenuItem/CreateActionMenuItem';
import { CreateMenuItem } from '../CreateButton.types';

interface CreateActionDrawerProps {
  isOpen: boolean;
  onOpenChange: () => void;
  label: string;
  authorizedOptions: CreateMenuItem[];
}

export const CreateActionDrawer: FC<CreateActionDrawerProps> = ({
  isOpen,
  onOpenChange,
  label,
  authorizedOptions,
}) => {
  return (
    <Drawer open={isOpen} onOpenChange={onOpenChange}>
      <DrawerContent data-testid="createButtonMenu" className="gap-1 p-2 pb-6">
        <DrawerHeader className="sr-only">
          <DrawerTitle>{label}</DrawerTitle>
        </DrawerHeader>

        {authorizedOptions.map((item) => (
          <CreateActionMenuItem
            key={item.key}
            item={item}
            onSelect={onOpenChange}
          />
        ))}
      </DrawerContent>
    </Drawer>
  );
};
